/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Math.Distance
 */

module.exports = {

    Between: require('./DistanceBetween'),
    Power: require('./DistancePower'),
    Squared: require('./DistanceSquared')

};



//////////////////
// WEBPACK FOOTER
// ./math/distance/index.js
// module id = 820
// module chunks = 0